import axios from 'axios'
import { ref } from 'vue'
import { useToast } from 'vue-toast-notification'

export function useQuotes({
    onDeleted = () => {},
    onError = () => {},
}) {
    const $toast = useToast()

    const deleting = ref(false)

    const deleteQuote = async (id) => {
        try {
            deleting.value = true
            await axios.delete(`/api/quotes/${id}`)
            $toast.success('Devis supprimé', {
                position: 'top',
                duration: 5000,
                dismissible: true,
                pauseOnHover: true,
            })
            onDeleted()
        } catch (error) {
            onError(error)
        } finally {
            deleting.value = false
        }
    }

    return {
        deleting,
        deleteQuote,
    }
}
